import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { Text } from 'react-native';
import Login from './Login';
import SignUp from './SignUp';
import Game from './Game';
import HomeMenu from './HomeMenu';
import GameScreen from './GameScreen';
import ChangePassword from './ChangePassword';
import PasswordReset from './PasswordReset';

const Stack = createStackNavigator();

const config = {
  screens: {
    PasswordReset: 'forgot-password',
    Login: 'login',
    SignUp: 'register',
    ChangePassword: 'change-password/:key',
    Game: 'board',
  },
};

const linking = {
  prefixes: ['https://jamaicanstyledominoes.com',],
  config: config,
};

export default function AppNavigator(){
    return (
        <NavigationContainer linking={linking} fallback={<Text>Loading...</Text>}>
        <Stack.Navigator screenOptions={{
          headerShown: false
        }}>
          <Stack.Screen
            name="Login"
            component={Login}
          />

          <Stack.Screen
            name="GameScreen"
            component={GameScreen}
          />

          <Stack.Screen
            name="SignUp"
            component={SignUp}
          />

          <Stack.Screen
            name="HomeMenu"
            component={HomeMenu}
          />

          <Stack.Screen
            name="PasswordReset"
            component={PasswordReset}
          />

          <Stack.Screen
            name="ChangePassword"
            component={ChangePassword}
          />

        <Stack.Screen
            name="Game"
            component={Game}
          />

        </Stack.Navigator>
      </NavigationContainer>
    )
}